import { TrackingManager } from "../utils/TrackingManager"
;(function () {
    const consentCookieName = window["cookieName"]
    const trackingManager = new TrackingManager(consentCookieName)

    const form = document.getElementById("cookie-consent-form")
    const toggles = form.querySelectorAll(
        ".category-toggle"
    ) as NodeListOf<HTMLInputElement>
    // Query-Parameter TargetUrl auslesen und auf interne Pfade begrenzen
    const rawTargetUrl = new URLSearchParams(window.location.search).get(
        "TargetUrl"
    )

    function getRedirectTarget() {
        if (!rawTargetUrl) return null
        let decoded
        try {
            decoded = decodeURIComponent(rawTargetUrl)
        } catch {
            return null
        }
        // Externe / absolute URLs verhindern (Open Redirect Schutz)
        if (/^(https?:|\/\/)/i.test(decoded)) return null
        if (/^javascript:/i.test(decoded)) return null
        // Nur relative oder Root-Pfade erlauben
        if (
            decoded.startsWith("/") ||
            decoded.startsWith("./") ||
            decoded.startsWith("../")
        )
            return decoded
        // Falls nur ein Segment (z.B. Dashboard) angegeben ist, vorne Slash ergänzen
        return "/" + decoded.replace(/^\/+/, "")
    }

    function getRequiredKeys() {
        return Array.from(toggles)
            .filter((t) => t.disabled)
            .map((t) => t.dataset.categoryKey)
    }

    function acceptEssential() {
        const required = getRequiredKeys()
        trackingManager.switchCategoryState(required, true)
        trackingManager.persist()
        showSaved()
    }

    function acceptAll() {
        const all = Array.from(toggles).map((t) => t.dataset.categoryKey)
        //writeConsent(all)
        trackingManager.switchCategoryState(all, true)
        trackingManager.persist()
        showSaved()
    }

    function saveSelection() {
        trackingManager.switchCategoryState(getRequiredKeys(), true)
        trackingManager.persist()
        showSaved()
    }

    function showSaved() {
        const toast = document.createElement("div")
        toast.className =
            "position-fixed bottom-0 end-0 m-3 alert alert-success shadow"
        toast.textContent = window["confirmation"]
        document.body.appendChild(toast)
        const target = getRedirectTarget()
        // Kurze Verzögerung, damit Toast sichtbar ist
        setTimeout(
            () => {
                toast.remove()
                if (target) window.location.href = target
            },
            target ? 800 : 4000
        )
    }

    function onChangeToggle(this: HTMLInputElement) {
        const categoryId = this.dataset.categoryKey
        const isGranted = this.checked
        trackingManager.switchCategoryState(categoryId, isGranted)
    }

    document.querySelectorAll(".category-toggle").forEach((el) => {
        el.addEventListener("change", onChangeToggle)
    })

    document
        .querySelector("#btn-accept-all")
        ?.addEventListener("click", acceptAll)
    document
        .querySelector("#btn-save-selection")
        ?.addEventListener("click", saveSelection)
    document
        .querySelector("#btn-accept-essential")
        ?.addEventListener("click", acceptEssential)
})()
